import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {catchError, map, Observable, of} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class MapsService {

    constructor(private httpClient: HttpClient) {

    }

    update(facilityId: string, mapType: MapType): Observable<Boolean> {
        let domain = environment.getMapServiceUrl()
        return this.httpClient
            .post(`https://${domain}/admin/update-tiles/${mapType}`, facilityId, {withCredentials: true, responseType: "text"})
            .pipe(
                map(() => true),
                catchError(() => of(false))
            )
    }
}

export enum MapType {
    Google = 'g',
    Bing = 'b',
}